"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLineItem = exports.getLineItems = void 0;
const api_1 = __importDefault(require("@aws-amplify/api"));
const rl_shared_1 = require("@asu-etx/rl-shared");
const hashUtils_1 = require("../utils/hashUtils");
const getLineItems = async (aws_exports) => {
    api_1.default.configure(aws_exports);
    rl_shared_1.logger.debug(`hitting endpoint GET:${rl_shared_1.GET_ASSIGNMENT_ENDPOINT}`);
    const lineItems = await api_1.default.get(rl_shared_1.LTI_API_NAME, rl_shared_1.GET_ASSIGNMENT_ENDPOINT, { queryStringParameters: { hash: hashUtils_1.getHash() } });
    return lineItems;
};
exports.getLineItems = getLineItems;
const deleteLineItem = async (aws_exports, assignmentId) => {
    api_1.default.configure(aws_exports);
    const results = await api_1.default.del(rl_shared_1.LTI_API_NAME, rl_shared_1.DELETE_LINE_ITEM, {
        queryStringParameters: {
            lineItemId: assignmentId,
            hash: hashUtils_1.getHash()
        }
    });
    return results;
};
exports.deleteLineItem = deleteLineItem;
